import {
  Save,
  Done,
  ArrowBack,
  ArrowForward,
  CleaningServices,
} from '@mui/icons-material'
import { Box } from '@mui/material'

import theme from 'src/styles/theme'
import { Button } from '../Button'
import * as S from './styles'

interface IBoxButtonsProps {
  isLastStep?: boolean
  disableNextButton?: boolean
  isLoading?: boolean
  onClickPrevius?: () => void
  onClickNext?: () => void
}

export const BoxButtons = (props: IBoxButtonsProps) => (
  <S.BoxButtons>
    <Button
      variant={'outlined'}
      onClick={props.onClickPrevius}
      startIcon={<ArrowBack />}
      disabled={props.isLoading}
    >
      Voltar
    </Button>

    <Box
      sx={{
        display: 'flex',
        gap: theme.layout.gap.medium,
        alignItems: 'center',
        justifyContent: 'end',
      }}
    >
      <Button
        type={'submit'}
        variant={'contained'}
        onClick={props.onClickNext}
        endIcon={props.isLastStep ? <Done /> : <ArrowForward />}
        disabled={props.disableNextButton}
        isLoading={props.isLoading}
      >
        {props.isLoading
          ? 'Salvando'
          : props.isLastStep
          ? 'Confirmar'
          : 'Avançar'}
      </Button>
    </Box>
  </S.BoxButtons>
)
